export default __webpack_public_path__ + "static/media/slider3.ae9b7d47.jpg";